/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { EncounterStartType } from "./EncounterStartType";

/**
 * Request schema for creating a Curai visit from a Nori conversation asynchronously
 */
export interface CreateCuraiVisitAsyncRequest {
  /** The ID of the origin conversation */
  origin_conversation_id: string;
  /** The ID of the clinic request */
  clinic_request_id: string;
  /** The type of encounter to start */
  encounter_type: EncounterStartType;
}
